// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2141":"b1d1cc8d","2324":"5b3a3581","5016":"c3a71a48"}[chunkId] + ".chunk.css");